export default __webpack_public_path__ + "87078e95d87f4b50fa925e6b50547ace.svg";